module.exports = __webpack_public_path__ + "static/media/close.f6b8cb2c.svg";